export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/569373b84d4fa61cda98164451d2ed57.svg";